export default __webpack_public_path__ + "static/media/twitter-icon.6c242369.svg";